import { useState, useEffect } from "react";
import {
    FaArrowRight,
    FaCalendarAlt,
    FaCheckCircle,
    FaChalkboardTeacher,
    FaClock,
    FaCode,
    FaCreditCard,
    FaEnvelopeOpenText,
    FaFileAlt,
    FaFileCode,
    FaFileSignature,
    FaFileWord,
    FaGlobeAsia,
    FaHotel,
    FaLightbulb,
    FaMapMarkerAlt,
    FaMicrochip,
    FaPaperPlane,
    FaPassport,
    FaPlaneDeparture,
    FaQuoteLeft,
    FaRocket,
    FaUsers,
    FaUserPlus,
    FaAward,
    FaLaptopCode,
} from "react-icons/fa";

import Footer from "../footer/Footer";
import CalendarCards from "../pages/CalendarCards";
import PricingCards from "../pages/PricingCards";
import containerStyles from "../pages/Container.module.css";
import styles from "./MainPage.module.css";
import Navbar from "../navbar/Navbar";
import { FaFile } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";


const heroSlides = [
    { id: "soudha", image: "/images/vidhansabha.png" },
    { id: "vidhana", image: "/images/vidhansoubha.png" },
    { id: "mysore", image: "/images/mysore-palace.png" },
    { id: "gombuz", image: "/images/gol-gombuz.png" },
    { id: "bidar", image: "/images/bidar-fort.png" },
    { id: "chitradurga", image: "/images/chitradugra-fort.png" },
    { id: "hampi", image: "/images/hampi.png" },
    { id: "radar", image: "/images/radar.png" },
    { id: "mpm", image: "/images/mpm-project.png" },
    { id: "twt", image: "/images/twt-project.png" },
];

const visaHelpData = [
    {
        icon: <FaEnvelopeOpenText />,
        title: "Invitation Letters",
        text: "Registered authors and delegates can request an official invitation letter to support their visa application.",
    },
    {
        icon: <FaFileSignature />,
        title: "Documentation Checklist",
        text: "A step-by-step checklist covering proof of registration, accommodation and financial support documents.",
    },
    {
        icon: <FaPlaneDeparture />,
        title: "Travel Advisory",
        text: "Guidance on entry requirements, processing timelines and nearest Indian consulates for international delegates.",
    },
];

const CountdownTimer = ({ targetDate }) => {
    const calculateTimeLeft = () => {
        const difference = +new Date(targetDate) - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <div className={styles.countdownContainer}>
            <div className={styles.countdownItem}>
                <span className={styles.countdownNumber}>{timeLeft.days ?? 0}</span>
                <span className={styles.countdownLabel}>Days</span>
            </div>
            <div className={styles.countdownItem}>
                <span className={styles.countdownNumber}>{timeLeft.hours ?? 0}</span>
                <span className={styles.countdownLabel}>Hrs</span>
            </div>
            <div className={styles.countdownItem}>
                <span className={styles.countdownNumber}>{timeLeft.minutes ?? 0}</span>
                <span className={styles.countdownLabel}>Min</span>
            </div>
            <div className={styles.countdownItem}>
                <span className={styles.countdownNumber}>{timeLeft.seconds ?? 0}</span>
                <span className={styles.countdownLabel}>Sec</span>
            </div>
        </div>
    );
};

const MainPage = () => {

    const navigate = useNavigate();
    const [activeSlide, setActiveSlide] = useState(0);

    const eventDate = '2027-03-15T00:00:00';

    // Auto-scroll the hero visual every 4.5s
    useEffect(() => {
        const timer = setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % heroSlides.length);
        }, 4500);

        return () => clearInterval(timer);
    }, []);

    const goSubmitPaper = () => {
        window.open('https://edas.info/newPaper.php?c=35646', '_blank', 'noopener,noreferrer');
    };

    // const downloadBrochure = () => {
    //     window.open('/documents/IVEC2027-Flyer-Ver-02B.pdf', '_blank', 'noopener,noreferrer');
    // };

    const downloadBrochure = () => {
        const link = document.createElement('a');
        link.href = '/documents/IVEC2027-Flyer-Ver-02B.pdf';
        link.download = 'Event-Brochure.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const openLink = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div className={styles.page} id="top">

            {/* =========================================================
                HERO
            ========================================================= */}
            <section className={styles.hero}>

                {/* Auto-scrolling background photos only — no boxed panel */}
                {heroSlides.map((slide, index) => (
                    <div
                        key={slide.id}
                        aria-hidden="true"
                        className={`${styles.heroBgSlide} ${index === activeSlide ? styles.heroBgSlideActive : ""
                            }`}
                        style={{ backgroundImage: `url(${slide.image})` }}
                    />
                ))}

                <div className={styles.heroOverlay}></div>

                <div className={`container position-relative ${containerStyles.cscontainer}`}>

                    <div className={styles.heroContent}>

                        <div className={styles.heroBadge}>
                            <FaRocket />
                            <span>28th International Conference</span>
                        </div>

                        <h1 className={styles.heroTitle}>
                            IVEC 2027
                        </h1>

                        <h2 className={styles.heroSubtitle}>
                            International Vacuum Electronics Conference
                        </h2>

                        <p className={styles.heroTagline}>
                            Advancing Vacuum Electronics for a Smarter &
                            Sustainable Future
                        </p>

                        <div className={styles.heroDetails}>

                            <div className={styles.heroDetail}>
                                <FaCalendarAlt />
                                <div>
                                    <strong>15 – 18 March 2027</strong>
                                </div>
                            </div>

                            <div className={styles.heroDetail}>
                                <FaMapMarkerAlt />
                                <div>
                                    <strong>Hilton Bengaluru Embassy Manyata Business Park</strong>
                                    <span>Bangalore, India</span>
                                    <CountdownTimer targetDate={eventDate} />
                                </div>
                            </div>

                        </div>

                        <div className={styles.heroButtons}>

                            <button
                                onClick={() => downloadBrochure()}
                                className={styles.tertiaryHeroButton}
                            >
                                Download Flyer
                                <FaFile />
                            </button>

                            <button
                                onClick={() => goSubmitPaper()}
                                className={styles.primaryHeroButton}
                            >
                                Submit Paper
                                <FaArrowRight />
                            </button>

                            <button
                                className={styles.secondaryHeroButton}
                                onClick={() => navigate("/registration")}
                            >
                                Register Now
                                <FaUserPlus />
                            </button>

                        </div>

                    </div>
                </div>

            </section>

            {/* =========================================================
                QUICK INFO
            ========================================================= */}
            <section className={styles.quickInfoWrapper}>
                <div className={`container ${containerStyles.cscontainer}`}>

                    <div className={styles.quickInfo}>

                        <div className={styles.quickItem}>
                            <div className={styles.quickIcon}>
                                <FaUsers />
                            </div>

                            <div>
                                <strong>Global Platform</strong>
                                <span>
                                    for Researchers, Engineers & Scientists
                                </span>
                            </div>
                        </div>

                        <div className={styles.quickItem}>
                            <div className={styles.quickIcon}>
                                <FaChalkboardTeacher />
                            </div>

                            <div>
                                <strong>Technical Sessions</strong>
                                <span>
                                    Keynotes, Tutorials, Workshops & Exhibitions
                                </span>
                            </div>
                        </div>

                        <div className={styles.quickItem}>
                            <div className={styles.quickIcon}>
                                <FaLightbulb />
                            </div>

                            <div>
                                <strong>Innovation & Collaboration</strong>
                                <span>
                                    Shaping the Future of Vacuum Electronics
                                </span>
                            </div>
                        </div>

                        <div className={styles.quickItem}>
                            <div className={styles.quickIcon}>
                                <FaClock />
                            </div>

                            <div>
                                <strong>Important Dates</strong>
                                <span>
                                    Paper Submission Opens: 01 Aug 2026
                                </span>
                            </div>
                        </div>

                        <div className={styles.quickItem}>
                            <div className={styles.quickIcon}>
                                <FaEnvelopeOpenText />
                            </div>

                            <div>
                                <strong>Stay Updated</strong>
                                <span>
                                    Subscribe to our newsletter for the latest updates
                                </span>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <main className={`container ${containerStyles.cscontainer}`}>

                {/* =====================================================
                    WELCOME
                ===================================================== */}
                <section id="welcome-section" className={styles.section}>
                    <div className={styles.sectionHeading}>
                        <div className={styles.sectionIcon}>
                            <FaQuoteLeft />
                        </div>

                        <div>
                            <span className={styles.sectionEyebrow}>
                                Welcome
                            </span>

                            <h2>
                                Welcome to IVEC 2027
                            </h2>
                        </div>
                    </div>

                    <div className="row g-4 align-items-center">

                        <div className="col-lg-8">

                            <p className={styles.largeParagraph}>
                                On behalf of the IVEC-2027 Conference
                                Committee, we warmly welcome you to the
                                28th International Vacuum Electronics
                                Conference in Bengaluru, the Garden City
                                of India.
                            </p>

                            <p className={styles.paragraph}>
                                IVEC 2027 will bring together a diverse
                                international community working across
                                vacuum electronics, high-power microwave
                                systems, advanced electronic devices,
                                materials, manufacturing technologies
                                and related research domains.
                            </p>

                            <p className={styles.paragraph}>
                                The conference provides an environment
                                where fundamental research meets
                                practical engineering. Participants will
                                have opportunities to exchange ideas,
                                present recent discoveries, discuss
                                emerging challenges and establish
                                meaningful collaborations.
                            </p>

                            <p className={styles.paragraph}>
                                Bengaluru's standing as India's leading
                                technology and aerospace hub makes it a
                                fitting host city — home to major
                                research institutions, defence
                                laboratories and a thriving electronics
                                manufacturing ecosystem, offering
                                delegates a unique opportunity to pair
                                academic exchange with industry
                                exposure.
                            </p>

                        </div>

                        <div className="col-lg-4">

                            <div className={styles.highlightCard}>

                                <div className={styles.highlightIcon}>
                                    <FaGlobeAsia />
                                </div>

                                <h3>
                                    A Global Scientific Forum
                                </h3>

                                <p>
                                    Connecting academia, research
                                    institutions, technology companies
                                    and industry professionals through
                                    knowledge and collaboration.
                                </p>

                                <div className={styles.highlightLine}></div>

                                <strong>
                                    Bengaluru • India • 2027
                                </strong>

                            </div>

                        </div>

                    </div>
                </section>

                {/* =====================================================
                    CONFERENCE STATS
                ===================================================== */}
                <section className={styles.statsSection}>

                    <div className="row g-4">

                        <div className="col-6 col-lg-3">
                            <div className={styles.statCard}>
                                <FaUsers />
                                <strong>Global</strong>
                                <span>Participation</span>
                            </div>
                        </div>

                        <div className="col-6 col-lg-3">
                            <div className={styles.statCard}>
                                <FaMicrochip />
                                <strong>Advanced</strong>
                                <span>Technology</span>
                            </div>
                        </div>

                        <div className="col-6 col-lg-3">
                            <div className={styles.statCard}>
                                <FaLightbulb />
                                <strong>Innovation</strong>
                                <span>& Research</span>
                            </div>
                        </div>

                        <div className="col-6 col-lg-3">
                            <div className={styles.statCard}>
                                <FaAward />
                                <strong>28th</strong>
                                <span>Edition</span>
                            </div>
                        </div>

                    </div>
                </section>

                {/* =====================================================
                    VENUE
                ===================================================== */}
                <section id="venue-section" className={styles.section}>

                    <div className={styles.sectionHeading}>
                        <div className={styles.sectionIcon}>
                            <FaHotel />
                        </div>

                        <div>
                            <span className={styles.sectionEyebrow}>
                                Destination
                            </span>

                            <h2>
                                Conference Venue
                            </h2>
                        </div>
                    </div>

                    <div className="row g-4 align-items-stretch">

                        <div className="col-lg-5">

                            <span className={styles.venueLabel}>
                                Premium Conference Experience
                            </span>

                            <h3 className={styles.venueTitle}>
                                Hilton Bengaluru Embassy Manyata
                                Business Park
                            </h3>

                            <p className={styles.paragraph}>
                                Hilton Bengaluru Embassy Manyata Business
                                Park is a premier 5-star hotel located in
                                the heart of North Bengaluru. The venue
                                offers state-of-the-art conference
                                facilities, modern amenities and
                                world-class hospitality, making it an
                                ideal place for IVEC 2027.
                            </p>

                            <p className={styles.paragraph}>
                                The location combines modern conference
                                facilities with comfortable accommodation
                                and convenient connectivity, creating an
                                ideal setting for an international
                                scientific gathering.
                            </p>

                            <button
                                className={styles.venueDetailsButton}
                                onClick={() => navigate("/venue-section")}
                            >
                                Venue Details
                                <FaArrowRight />
                            </button>

                        </div>

                        <div className="col-lg-4">

                            <div
                                className={styles.venueVisual}
                                style={{ backgroundImage: "url(/images/venue.jpg)" }}
                            >

                                <div className={styles.venueFloatingCard}>
                                    <FaMapMarkerAlt />
                                    <div>
                                        <strong>Bengaluru</strong>
                                        <span>
                                            Karnataka, India
                                        </span>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-3">

                            <div className={styles.venueFeatures}>

                                <div>
                                    <FaCheckCircle />
                                    <div>
                                        <strong>Modern Conference Halls</strong>
                                        <span>Fully equipped for technical sessions & events</span>
                                    </div>
                                </div>

                                <div>
                                    <FaCheckCircle />
                                    <div>
                                        <strong>Comfortable Stay</strong>
                                        <span>Luxurious rooms & suites for a relaxing experience</span>
                                    </div>
                                </div>

                                <div>
                                    <FaCheckCircle />
                                    <div>
                                        <strong>Easy Accessibility</strong>
                                        <span>Well-connected to airport, city & major transport</span>
                                    </div>
                                </div>

                                <div>
                                    <FaCheckCircle />
                                    <div>
                                        <strong>Warm Hospitality</strong>
                                        <span>Experience world-class service and local charm</span>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </section>

                {/* =====================================================
                    TOPICS
                ===================================================== */}
                <section id="topics" className={styles.section}>

                    <div className={styles.sectionHeading}>
                        <div className={styles.sectionIcon}>
                            <FaMicrochip />
                        </div>

                        <div>
                            <span className={styles.sectionEyebrow}>
                                Research
                            </span>

                            <h2>
                                Conference Focus Areas
                            </h2>
                        </div>
                    </div>

                    <p className={styles.sectionIntro}>
                        IVEC 2027 encourages contributions covering
                        fundamental research, applied technologies and
                        emerging developments within vacuum electronics
                        and associated engineering disciplines.
                    </p>

                    <div className="row g-4">

                        {[
                            [
                                "Vacuum Electronics",
                                "Advanced vacuum electronic devices, systems and technologies.",
                                <FaMicrochip />,
                            ],
                            [
                                "High-Power Systems",
                                "Research in high-power microwave and electronic systems.",
                                <FaRocket />,
                            ],
                            [
                                "Materials & Devices",
                                "Novel materials, components, fabrication and device technologies.",
                                <FaCode />,
                            ],
                            [
                                "Emerging Technologies",
                                "New approaches shaping the next generation of electronic systems.",
                                <FaLightbulb />,
                            ],
                        ].map(([title, text, icon], index) => (
                            <div className="col-md-6 col-xl-3" key={index}>
                                <div className={styles.topicCard}>

                                    <div className={styles.topicIcon}>
                                        {icon}
                                    </div>

                                    <h3>{title}</h3>

                                    <p>{text}</p>

                                    <span className={styles.topicNumber}>
                                        0{index + 1}
                                    </span>

                                </div>
                            </div>
                        ))}

                    </div>
                </section>

                {/* =====================================================
                    PROGRAMME
                ===================================================== */}
                <section id="programme" className={styles.section}>

                    <div className={styles.sectionHeading}>
                        <div className={styles.sectionIcon}>
                            <FaChalkboardTeacher />
                        </div>

                        <div>
                            <span className={styles.sectionEyebrow}>
                                Experience
                            </span>

                            <h2>
                                Conference Programme
                            </h2>
                        </div>
                    </div>

                    <div className="row g-4">

                        <div className="col-md-4">
                            <div className={styles.programmeCard}>
                                <div className={styles.programmeIcon}>
                                    <FaChalkboardTeacher />
                                </div>

                                <h3>Plenary Talks</h3>

                                <p>
                                    Hear from leading experts and
                                    distinguished researchers discussing
                                    major developments and future
                                    directions.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className={styles.programmeCard}>
                                <div className={styles.programmeIcon}>
                                    <FaLaptopCode />
                                </div>

                                <h3>Technical Sessions</h3>

                                <p>
                                    Explore peer-reviewed research,
                                    engineering advances and practical
                                    applications through focused
                                    technical sessions.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className={styles.programmeCard}>
                                <div className={styles.programmeIcon}>
                                    <FaUsers />
                                </div>

                                <h3>Networking</h3>

                                <p>
                                    Connect with scientists, engineers,
                                    students and industry professionals
                                    from around the world.
                                </p>
                            </div>
                        </div>

                    </div>
                </section>

                {/* =====================================================
                    AUTHOR INSTRUCTIONS
                ===================================================== */}
                <section id="author-instructions" className={styles.section}>

                    <div className={styles.sectionHeading}>
                        <div className={styles.sectionIcon}>
                            <FaFileAlt />
                        </div>

                        <div>
                            <span className={styles.sectionEyebrow}>
                                Authors
                            </span>

                            <h2>
                                Author Instructions & Templates
                            </h2>
                        </div>
                    </div>

                    <p className={styles.sectionIntro}>
                        Authors are encouraged to prepare their
                        submissions carefully and follow the required
                        formatting guidelines for abstracts and
                        conference papers.
                    </p>

                    <div className={styles.templateContainer}>

                        <div className="row g-4">

                            <div className="col-lg-6">

                                <div className={styles.templateCard}>

                                    <div className={styles.templateHeader}>
                                        <FaFileWord />
                                        <div>
                                            <h3>Microsoft Word</h3>
                                            <span>Conference templates</span>
                                        </div>
                                    </div>

                                    <div className={styles.templateItem}
                                        onClick={() => openLink("https://www.ieeeivec.org/assets/MicrosoftWord-letter.doc")}
                                    >
                                        <FaFileWord />
                                        <span>US Letter Template</span>
                                        <small>DOC</small>
                                    </div>

                                    <div className={styles.templateItem}
                                        onClick={() => openLink("https://www.ieeeivec.org/assets/MicrosoftWord-A4.doc")}
                                    >
                                        <FaFileWord />
                                        <span>A4 Template</span>
                                        <small>DOC</small>
                                    </div>

                                    <div className={styles.templateItem}
                                        onClick={() => openLink("https://www.ieeeivec.org/assets/IVEC_2022-Sample-Abstract.pdf")}
                                    >
                                        <FaFileAlt />
                                        <span>Sample Abstract</span>
                                        <small>PDF</small>
                                    </div>


                                </div>

                            </div>

                            <div className="col-lg-6">

                                <div className={styles.templateCard}>

                                    <div className={styles.templateHeader}>
                                        <FaFileCode />
                                        <div>
                                            <h3>LaTeX Templates</h3>
                                            <span>Technical formatting</span>
                                        </div>
                                    </div>

                                    <div className={styles.templateItem}
                                        onClick={() => openLink("https://www.ieeeivec.org/assets/Template_Instructions.pdf")}
                                    >
                                        <FaFileAlt />
                                        <span>Template Instructions</span>
                                        <small>PDF</small>
                                    </div>

                                    <div className={styles.templateItem}
                                        onClick={() => openLink("https://www.ieeeivec.org/assets/LaTeX-template_7-9-18.zip")}
                                    >
                                        <FaFileCode />
                                        <span>Conference Template</span>
                                        <small>ZIP</small>
                                    </div>

                                    <div className={styles.templateItem}
                                        onClick={() => openLink("https://www.ieeeivec.org/assets/LaTeX_BibliographyFilesWindows_IEEEtranBST2.zip")}
                                    >
                                        <FaFileCode />
                                        <span>Bibliography Files</span>
                                        <small>ZIP</small>
                                    </div>


                                </div>

                            </div>

                        </div>

                        <div className={styles.submissionBanner}>

                            <div>
                                <FaPaperPlane />
                            </div>

                            <div>
                                <strong>
                                    Ready to submit your research?
                                </strong>

                                <span>
                                    Prepare your abstract according to
                                    the conference guidelines and proceed
                                    with your submission.
                                </span>
                            </div>

                            <button
                            >
                                View Important Dates
                                <FaArrowRight />
                            </button>

                        </div>

                    </div>
                </section>

                {/* =====================================================
                    CALENDAR + PRICING — one animated, colour-coded
                    card row each, instead of plain tables.
                ===================================================== */}
                <div className="row g-4">

                    {/* CALENDAR */}
                    <div className="col-12">

                        <section id="calendar-section" className={styles.section}>

                            <div className={styles.sectionHeading}>
                                <div className={styles.sectionIcon}>
                                    <FaCalendarAlt />
                                </div>

                                <div>
                                    <span className={styles.sectionEyebrow}>
                                        Schedule
                                    </span>

                                    <h2>Calendar of Events</h2>
                                </div>
                            </div>

                            <CalendarCards />

                        </section>

                    </div>

                    {/* PRICING */}
                    <div className="col-12">

                        <section id="pricing-section" className={styles.section}>

                            <div className={styles.sectionHeading}>
                                <div className={styles.sectionIcon}>
                                    <FaCreditCard />
                                </div>

                                <div>
                                    <span className={styles.sectionEyebrow}>
                                        Registration
                                    </span>

                                    <h2>Registration Pricing</h2>
                                </div>
                            </div>

                            <PricingCards />

                        </section>

                    </div>

                </div>

                {/* =====================================================
                    VISA HELP
                ===================================================== */}
                <section id="visa-help" className={styles.section}>

                    <div className={styles.sectionHeading}>
                        <div className={styles.sectionIcon}>
                            <FaPassport />
                        </div>

                        <div>
                            <span className={styles.sectionEyebrow}>
                                International Delegates
                            </span>

                            <h2>Visa Information</h2>
                        </div>
                    </div>

                    <p className={styles.sectionIntro}>
                        IVEC 2027 is committed to supporting international
                        delegates through every step of the visa process,
                        so travel logistics never stand in the way of
                        attending.
                    </p>

                    <div className="row g-4">

                        {visaHelpData.map((item, index) => (
                            <div className="col-md-4" key={index}>
                                <div className={styles.topicCard}>

                                    <div className={styles.topicIcon}>
                                        {item.icon}
                                    </div>

                                    <h3>{item.title}</h3>

                                    <p>{item.text}</p>

                                </div>
                            </div>
                        ))}

                    </div>
                </section>

                {/* =====================================================
                    SPONSORS
                ===================================================== */}
                <section id="sponsors" className={styles.section}>

                    <div className={styles.sectionHeading}>
                        <div className={styles.sectionIcon}>
                            <FaUsers />
                        </div>

                        <div>
                            <span className={styles.sectionEyebrow}>
                                Partnership
                            </span>

                            <h2>Sponsors & Exhibitors</h2>
                        </div>
                    </div>

                    <p className={styles.sectionIntro}>
                        IVEC 2027 welcomes organizations interested in
                        supporting innovation, showcasing technology and
                        connecting with the international vacuum
                        electronics community.
                    </p>

                    <div className="row g-4">

                        <div className="col-md-4">
                            <div className={styles.sponsorCard}>
                                <div>
                                    <FaRocket />
                                </div>

                                <h3>Technology Partners</h3>

                                <p>
                                    Showcase advanced technologies,
                                    products and solutions to a focused
                                    technical audience.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className={styles.sponsorCard}>
                                <div>
                                    <FaGlobeAsia />
                                </div>

                                <h3>Industry Sponsors</h3>

                                <p>
                                    Build relationships with researchers,
                                    engineers and decision-makers from
                                    around the world.
                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className={styles.sponsorCard}>
                                <div>
                                    <FaLightbulb />
                                </div>

                                <h3>Innovation Showcase</h3>

                                <p>
                                    Present emerging technologies and
                                    contribute to the future of vacuum
                                    electronics.
                                </p>
                            </div>
                        </div>

                    </div>
                </section>

                {/* =====================================================
                    AWARDS
                ===================================================== */}
                <section id="awards" className={styles.awardsSection}>

                    <div className="row align-items-center g-4">

                        <div className="col-lg-8">

                            <span className={styles.awardEyebrow}>
                                Recognition & Excellence
                            </span>

                            <h2>
                                Celebrating Research &
                                Innovation
                            </h2>

                            <p>
                                IVEC 2027 aims to recognize outstanding
                                technical contributions, innovative
                                research and exceptional participation.
                                Awards and recognition programmes provide
                                an opportunity to highlight promising
                                ideas and achievements within the
                                community.
                            </p>

                        </div>

                        <div className="col-lg-4">
                            <div className={styles.awardIcon}>
                                <FaAward />
                            </div>
                        </div>

                    </div>

                </section>

            </main>

        </div>
    );
};

export default MainPage;